import API from "../../api";
import {API_SEARCH_INSPECTION_HISTORY_CONFIRM, API_CANCEL_INSPECTION} from "../../constants/api";

const getInformationInspection = async (workflowId, inspectionId, queryParams={}) => {
  try {
    const response = await API.get(API_SEARCH_INSPECTION_HISTORY_CONFIRM(workflowId, inspectionId, queryParams));
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const submitInformationInspection = async (workflowId, inspectionId) => {
  try {
    const response = await API.post(API_SEARCH_INSPECTION_HISTORY_CONFIRM(workflowId, inspectionId, {}), {});
    return response.data;
  } catch (e) {
    throw e.response;
  }
};


const cancelInspection = async (inspectionId) => {
  try {
    const response = await API.post(API_CANCEL_INSPECTION(inspectionId), {});
    return response.data;
  } catch (e) {
    throw e.response;
  }
};


const InspectionHistoryConfirm = {
  getInformationInspection,
  submitInformationInspection,
  cancelInspection
};

export {
  InspectionHistoryConfirm as default,
  getInformationInspection,
  submitInformationInspection,
  cancelInspection
}